<template>
  <a-select v-model="iValue"
            allowClear
            show-search
            :placeholder="placeholder || 'Seleccione una opción'"
            :options="options"
            :disabled="disabled"
            :filter-option="filterOption"
            option-filter-prop="children"
            @change="handleChange"
            v-bind="slConfig">
    <template v-for="customSlot in customSlots" :slot="customSlot">
      <slot :name="customSlot"></slot>
    </template>
  </a-select>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import JqHttpUtil from '@/util/JqHttpUtil'

  export default {
    props: ['value', 'selectedObj', 'placeholder', 'endpoint', 'selectConfig', 'cache', 'params', 'disabled', 'count', 'customSlots'],
    data () {
      return {
        iValue: undefined,
        options: [],
        slConfig: {}
      }
    },
    mounted () {
      this.slConfig = {...this.slConfig, ...this.selectConfig}
      this.httpClient = new JqHttpUtil(this.endpoint + '/dropdown')
      this.iValue = this.value
      this.loadOptions()
    },
    methods: {
      loadOptions () {
        if (this.slConfig.loading) return

        this.loading(true)
        this.options = []
        this.httpClient.get(this.params || {}, {
          cache: typeof this.cache === 'undefined' ? true : this.cache
        }, (response) => {
          this.clearOptions()
          if (response.data.length === 0) {
            this.options.push({
              value: '',
              key: 'na',
              label: 'Sin resultados',
              disabled: true
            })
            this.clear()
          } else {
            this.addOptions(this.transformOptions(response.data))
            this.validateOptionsIncludeValue()
          }
        }, () => {
          this.clearOptions()
          this.options.push({
            value: '',
            key: 'na',
            label: 'Error interno',
            disabled: true
          })
        }).always(() => {
          this.loading(false)
          this.$emit('update:count', this.options.length)
        })
      },
      handleChange (value) {
        this.$emit('input', value)
        this.$emit('change', value)
        for (let i = 0; i < this.options.length; i++) {
          const option = this.options[i]

          if (option.value === value) {
            this.$emit('update:selectedObj', option.obj)
            return
          }
        }
        this.$emit('update:selectedObj', undefined)
      },
      validateOptionsIncludeValue () {
        if (!JsUtils.isEmpty(this.iValue) && this.options.length > 0) {
          for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i]
            if (option.value.toString() === this.iValue.toString()) {
              this.$emit('update:selectedObj', option.obj)
              return
            }
          }

          this.clear()
        }
      },
      loading (loading) {
        this.slConfig.loading = loading
        this.slConfig.disabled = loading
        this.slConfig.allowClear = !loading

        this.slConfig = {...this.slConfig}
      },
      clearOptions () {
        this.options.splice(0, this.options.length)
      },
      transformOptions (response) {
        return response.map(option => {
          option.value = option.value ? option.value : ''
          return {
            value: option.value.toString(),
            key: option.value.toString(),
            label: option.text,
            obj: option
          }
        })
      },
      addOptions (options) {
        this.options.push(...options)
      },
      filterOption (valorBuscado, selectOption) {
        return selectOption.componentOptions.children[0].text.toLowerCase().indexOf(valorBuscado.toLowerCase()) >= 0
      },
      clear () {
        this.iValue = undefined
        this.handleChange(undefined)
      }
    },
    watch: {
      value () {
        if (this.iValue !== this.value) {
          this.iValue = this.value
          this.handleChange(this.value)
        }
      },
      params (newVal, oldVal) {
        if (!JsUtils.isEqual(newVal, oldVal)) {
          this.loadOptions()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/v2/dropdown.vue